/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  span {
    margin: auto 4px;
    padding: 0 8px;
    color: #c3c3c3;
  }
  svg {
    vertical-align: middle;
  }
`;
